import { withStyles, createStyles, makeStyles } from "@material-ui/core/styles";
import { TableRow } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(25),
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
  },
  mainHeading: {
    margin: 0,
    fontSize: theme.typography.pxToRem(32),
  },
  description: {
    fontSize: theme.typography.pxToRem(13),
  },
  noData: {
    fontSize: theme.typography.pxToRem(20),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}));

export const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
